import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dd-highlighted" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Use phrase settings to track words in phrases", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"900px"} }, null, -1)
const _hoisted_4 = { class: "dialog-card pb-0 px-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "section-title mb-2 px-d" }, "Phrase setting", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "px-d" }, "Specify the number of words before the main word and the number of words after the selected word", -1)
const _hoisted_7 = { class: "drilldown-buttons scroll-content px-d" }
const _hoisted_8 = { class: "translation-cell" }
const _hoisted_9 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_10 = { class: "flex-column-start" }
const _hoisted_11 = { class: "flex-column-start" }
const _hoisted_12 = { class: "dialog-actions" }

import { drilldownApi } from '@/api/drilldown';
import { useDialogStore } from '@/stores/dialogs';
import { replace } from '@/utils/vue';
import { h, onMounted, reactive, ref, watch } from 'vue';
import Table from '../Table.vue';
import VBlockListSelect from '../VBlockListSelect.vue';
import VButton from '../VButton.vue';
import VChips from '../VChips.vue';
import VPagination from '../VPagination.vue';
import VReplySetSelectStats from '../VReplySetSelectStats.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DrilldownDialog',
  props: {
    word: null
  },
  setup(__props: any) {

const props = __props as { word: string }


const dialogStore = useDialogStore()

const params = reactive({
  left_word_count: 0,
  right_word_count: 0,
  page: 1,
  sort: undefined
})
const initialPending = ref(true)
let isExists = false
const meta = reactive({ totalCount: 0, pageCount: 1, currentPage: 1, perPage: 20 })

onMounted(async () => {
  try {
    const resp = await drilldownApi.get(props.word)
    if (resp) {
      isExists = true
      params.left_word_count = resp.left_word_count
      params.right_word_count = resp.right_word_count
    }
  } finally {
    initialPending.value = false
  }
})

const setLeftWordCount = (count: number) => {
  if (params.left_word_count === count) {
    params.left_word_count = 0
  } else {
    params.left_word_count = count
  }
}
const setRightWordCount = (count: number) => {
  if (params.right_word_count === count) {
    params.right_word_count = 0
  } else {
    params.right_word_count = count
  }
}

const columns = {
  word: { title: "Word" },
  translation: { title: "Translation" },
  mentions: { title: "Mentions", sort: true },
  block_lists: { title: "Blocklist", width: 140 },
  replies_sets: { title: "Replies  Set", width: 140, fallback: "-" },
}

const data = reactive([])
const dataPending = ref(false)

watch([params, initialPending], async ([params]) => {
  if (initialPending.value) return
  dataPending.value = true
  data.length = 0
  try {
    const { left_word_count, right_word_count, ...otherParams } = params
    const resp = await drilldownApi.preview({ left_word_count, right_word_count, word: props.word }, otherParams)
    replace(data, resp.elements)
    replace(meta, resp._meta)
    dataPending.value = false
  } catch(e) {
    dataPending.value = false
  }
}, { deep: true, immediate: true })

const pending = ref(false)
const apply = async () => {
  pending.value = true
  try {
    if (isExists) {
      await drilldownApi.update({ word: props.word, left_word_count: params.left_word_count, right_word_count: params.right_word_count })
    } else {
      await drilldownApi.create({ word: props.word, left_word_count: params.left_word_count, right_word_count: params.right_word_count })
    }
    dialogStore.close()
  } catch(e) {
    pending.value = false
  }
}

const RenderWord = ({ word }: any) => {

  const matched = word.matchAll(new RegExp(props.word, "gi"))
  if (!matched) return word

  const arr = []
  let lastIndex = 0
  for (let match of matched) {
    arr.push(word.slice(lastIndex, match.index))
    
    const endIndex = match.index!+ props.word.length
    arr.push(h('span', { class: "dd-highlighted" }, word.slice(match.index, endIndex )))
    lastIndex = endIndex
  }
  arr.push(word.slice(lastIndex, word.length))

  return arr
}

const setPage = (page: number) => {
  params.page = page
  meta.currentPage = page
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(props.word), 1),
      _createTextVNode(" drilldown")
    ]),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(VButton, {
          class: _normalizeClass({ active: params.left_word_count === 2}),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setLeftWordCount(2)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("+2 words")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(VButton, {
          class: _normalizeClass({ active: params.left_word_count === 1}),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setLeftWordCount(1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("+1 word")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(VButton, { class: "filled" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.word), 1)
          ]),
          _: 1
        }),
        _createVNode(VButton, {
          class: _normalizeClass({ active: params.right_word_count === 1}),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (setRightWordCount(1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("+1 word")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(VButton, {
          class: _normalizeClass({ active: params.right_word_count === 2}),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (setRightWordCount(2)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("+2 words")
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createVNode(Table, {
        columns: columns,
        data: data,
        loading: dataPending.value || initialPending.value,
        sort: params.sort,
        "onUpdate:sort": _cache[4] || (_cache[4] = ($event: any) => ((params.sort) = $event)),
        "disable-inner-sort": ""
      }, {
        word: _withCtx(({ cell }) => [
          _createVNode(RenderWord, { word: cell }, null, 8, ["word"])
        ]),
        translation: _withCtx(({ cell, item }) => [
          _createElementVNode("span", _hoisted_8, _toDisplayString(cell), 1),
          (cell !== 'en')
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.translation_word), 1))
            : _createCommentVNode("", true)
        ]),
        block_lists: _withCtx(({ item, cell }) => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(VBlockListSelect, {
              word: item.word,
              "word-item": item,
              selected: [],
              "ignore-items": cell,
              small: ""
            }, null, 8, ["word", "word-item", "ignore-items"]),
            _createVNode(VChips, { items: cell }, null, 8, ["items"])
          ])
        ]),
        replies_sets: _withCtx(({ item, cell }) => [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(VReplySetSelectStats, {
              word: item.word,
              "ignore-items": cell
            }, null, 8, ["word", "ignore-items"]),
            _createVNode(VChips, { items: cell }, null, 8, ["items"])
          ])
        ]),
        _: 1
      }, 8, ["data", "loading", "sort"]),
      _createVNode(VPagination, {
        meta: meta,
        onChangepage: setPage,
        class: "min"
      }, null, 8, ["meta"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(VButton, {
        disabled: pending.value,
        big: "",
        onClick: apply
      }, {
        default: _withCtx(() => [
          _createTextVNode("Save")
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(VButton, {
        secondary: "",
        big: "",
        onClick: _unref(dialogStore).close
      }, {
        default: _withCtx(() => [
          _createTextVNode("Cancel")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}
}

})